import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { AccountsModel } from '../models/accounts.model'

@Component({
  selector: 'app-ti-accounts-page',
  templateUrl: 'accounts-page.component.html',
  styleUrls: ['accounts-page.component.scss'],
  providers: [AccountsModel],
  imports: [RouterOutlet],
})
export class AccountsPageComponent {}
